<template>
  <section class="pt-0 bg-gray50">
    <div class="relative z-3 -top-45 flex justify-center px-40">
      <div class="flex bg-white rounded shadow community-filters flex-wrap">
        <button
            class="listing-filter-category listing-filter-category-active outline-none icon-s-grid"
            :class="{ 'listing-filter-category-active' : false }"
            @click="setFilter(null)"
        >All
        </button>
        <button
            class="listing-filter-category outline-none icon-s-single-family"
            :class="{ 'listing-filter-category-active' : false }"
            @click="setFilter('homes')"
        >Homes
        </button>
        <button
            class="listing-filter-category outline-none icon-s-land"
            :class="{ 'listing-filter-category-active' : false }"
            @click="setFilter('lots')"
        >Land
        </button>
        <a
            @click="viewMore"
            class="listing-filter-category icon-s-filters"
        >More Filters</a>
      </div>
    </div>

    <div class="mt-20">
      <Listings
          v-if="communityListings"
          :listings="communityListings"
          orientation="horizontal"
          class="fade"
          :view="view"
      />
    </div>

    <div class="w-full flex justify-center items-center -mt-90 pb-80">
      <a class="filled-button filled-button-red block cursor-pointer z-2"
         @click="viewMore">
        <span class="filled-button-content">View More</span>
        <span class="button-arrow filled-button-arrow"></span>
      </a>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

import Listings from '../listings/listings.vue';

// Loads active and sold residential cards for community detail pages.
export default {
  data() {
    return {
      view: 'list',
      communityListings: [],
      community: null,
      limit: 12,
      count: 0,
      counties: {
        'durham': '&counties=durham',
        'alamance': '&counties=alamance',
        'granville': '&counties=granville',
        'person': '&counties=person',
        'chatham': '&counties=chatham',
        'wake': '&counties=wake',
        'orange': '&counties=orange',
      },
      showAll: false,
      wwBrokers: '&brokers=70600&brokers=71581',
    };
  },
  computed: {},
  methods: {
    getListings(queryString = '') {

      if (this.community.type === 'lake') {
        queryString += '&neighborhoods=' + this.community.title
      } else if (this.community.type === 'city') {
        queryString += '&cities=' + encodeURIComponent(this.community.title)
      } else if (this.community.type === 'county') {
        queryString += this.counties[this.community.slug]
      }

      // Make sure it's not just getting residential, and it's not pulling any rentals
      queryString += '&type=residential&type=multifamily&type=land&status=Active&status=ActiveUnderContract&status=Pending';

      //////////////////////////////////////////////////////////////////////////////////////////
      // Getting the listings from the api: the double query conditional
      //////////////////////////////////////////////////////////////////////////////////////////
      //Double query
      // first query we want WW listings only
      // second query we want remaining listings with WW
      if (!this.showAll) {

        //set url with broker ids
        var queryStringWW = queryString + this.wwBrokers;

        //get WW listings
        this.getApiListings(queryStringWW).then(() => {

          //query for next set if there's room. Max listings = limit
          if (this.count < this.limit) {
            //fit remaining listings within the limit range
            var limit = this.limit - this.count;
            this.getApiListings(queryString, true, limit);
          }
        });
      }
      // sortOption != WW, business as usual
      else {
        this.getApiListings(queryString);
      }
      //////////////////////////////////////////////////////////////////////////////////////////

    },
    getApiListings(queryString, appendListings = false, limit = this.limit) {

      return axios
          .get(`https://api.simplyrets.com/properties?limit=${limit}&sort=-listdate${queryString}`, {
            auth: {
              username: 'dev_gkd161z1',
              password: '7331f601341j9871'
            }
          })
          .then(response => {
            var listings = response.data;

            //append listings
            if (appendListings && listings.length) {
              this.communityListings = this.communityListings.concat(listings)
            } else {
              this.communityListings = listings;
            }

            this.count += listings.length;
          });

    },
    setFilter(filter) {
      if (filter === null) {
        var type = '';
      } else if (filter === 'homes') {
        var type = `&type=residential&type=multifamily`;
      } else if (filter === 'lots') {
        var type = `&type=land`;
      }

      window.location.href = "/listings?community=" + this.community.title + type
    },
    viewMore() {

      window.location.href = "/listings?community=" + this.community.title;
    }
  },
  created() {
    this.community = window.community
    this.showAll = this.community.showAll

    this.getListings();
  },
  components: {
    Listings
  }
};
</script>
